import { NgModule } from '@angular/core';
import { WebConsoleContainerComponent } from './web-console-container.component';

@NgModule({
  declarations: [
    WebConsoleContainerComponent
  ],
  exports: [
    WebConsoleContainerComponent
  ]
})
export class WebConsoleContainerModule {}
